import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Star, Quote as QuoteIcon } from "lucide-react";
import { api } from "@/lib/api";

const reveal = {
  hidden: { opacity: 0, y: 40 },
  show: { opacity: 1, y: 0, transition: { duration: 0.7, ease: [0.22, 1, 0.36, 1] } },
};

export const Testimonials = () => {
  const [items, setItems] = useState([]);

  useEffect(() => {
    api.get("/testimonials").then(({ data }) => setItems(data)).catch(() => setItems([]));
  }, []);

  if (items.length === 0) return null;

  return (
    <section id="testimonials" className="relative bg-brand-ink py-24 md:py-36">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-14">
          <div>
            <div className="flex items-center gap-3 mb-6">
              <span className="h-px w-12 bg-brand-orange" />
              <span className="text-xs md:text-sm tracking-[0.25em] uppercase font-heading text-brand-orange">
                Reviews
              </span>
            </div>
            <h2 className="font-heading font-medium tracking-tight text-white text-4xl md:text-6xl leading-[1.05]">
              What our customers say.
            </h2>
          </div>
          <p className="text-white/60 font-body max-w-sm">
            Trusted by homeowners and businesses across Washington, Sunderland, Durham and Gateshead.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5" data-testid="testimonials-list">
          {items.map((t, i) => (
            <motion.div
              key={t.id}
              data-testid={`testimonial-${t.id}`}
              variants={reveal}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true, margin: "-40px" }}
              transition={{ delay: (i % 3) * 0.08 }}
              className="relative border border-white/10 bg-brand-surface p-8 flex flex-col"
            >
              <QuoteIcon size={34} className="text-brand-orange/30 mb-4" />
              <p className="text-white/80 font-body leading-relaxed flex-1">“{t.text}”</p>
              <div className="flex items-center gap-1 mt-6 mb-3">
                {Array.from({ length: 5 }).map((_, s) => (
                  <Star
                    key={s}
                    size={16}
                    className={s < t.rating ? "text-brand-orange fill-brand-orange" : "text-white/20"}
                  />
                ))}
              </div>
              <p className="font-heading text-white text-lg">{t.name}</p>
              {t.location && <p className="text-white/40 text-sm">{t.location}</p>}
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
